import axios from "axios";
import { BACKEND_API_GATEWAY_URL } from "../constants/appConstants";


const coreApi = axios.create({
  baseURL: BACKEND_API_GATEWAY_URL
});

coreApi.interceptors.response.use(
  (response) => response,
  async (error) => {
      const originalRequest = error.config;
      if (error.response && error.response.status === 401) {
          const newAccessToken = await refreshToken();
          if (newAccessToken) {
              originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
              return coreApi(originalRequest); 
          }
      }
      return Promise.reject(error);
  }
);

async function refreshToken() {

  try {
      const response = await coreApi.post('/auth/token', {
        refreshToken: JSON.parse(localStorage.getItem('userInfo'))?.refresh_token
      });
      const newAccessToken = response.data.accessToken;
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      const updatedUserInfo = {
        ...userInfo,
        token: response.data.accessToken
      };
      localStorage.setItem('userInfo', JSON.stringify(updatedUserInfo));
      coreApi.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
      return newAccessToken;
  } catch (error) {
      console.error('Unable to refresh token:', error);
      localStorage.clear();
      window.location.replace("/#");
      return null;
  }
}

export const getCorporateApi = async () => {
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .get(`corporate/membership/details`, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};

export const getCorporateListApi = async () => {
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .get(`corporate/details`, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};

export const getCorporateAdminApi = async (id) => {
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .get(`corporate/membership/info/${id}`, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};

export const getApplicationMemberForm=async(staffId)=>{
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .get(`corporate/membership/application/form/${staffId}`, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
}

export const getMembershipFormApi = async (id) => {
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .get(`corporate/membership/form/${id}`, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};

export const postSignupApi = async (singupRequestBody) => {
  const axiosConfig = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  const responseData = await coreApi
    .post(`register`, singupRequestBody, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};

export const sendMembershipFormsApi = async (requestBody) => {
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .post(`corporate/membership/form/send`, requestBody, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};

export const reSendMembershipFormsApi = async (requestBody) => {
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .post(`corporate/send/application/form/re-send`, requestBody, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};


export const submitMembershipFormsApi = async (requestBody) => {
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .post(`corporate/membership/form/send`, requestBody, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};

export const activateCorporateAccountApi = async (requestBody) => {
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .post(`activate/account`, requestBody, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};

export const bulkFormSubmitApi = async (requestBody) => {
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .post(`corporate/bulk/form/submit`, requestBody, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};

export const postLoginApi = async (loginRequestBody) => {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const responseData = await coreApi
    .post(`/auth/login`, loginRequestBody, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};

export const registerIndividualMember = async (requestBody) => {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const responseData = await coreApi
    .post(`Individual/membership/registration`, requestBody, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};

export const registerCorporateMember = async (requestBody) => {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const responseData = await coreApi
    .post(
      `corporate/membership/registration/${requestBody?.membershipId}/${requestBody?.corporateId}`,
      requestBody,
      axiosConfig
    )
    .then((response) => {
      return response.data;
    });
  return responseData;
};

export const getAllcountries = async () => {
  const responseData = await axios
    .get("https://restcountries.com/v3.1/all")
    .then((response) => {
      return response.data;
    })
    .catch((error) => console.error("Error fetching country data:", error));
    return responseData;
};

export const getBanksAndBranchApi = async () => {
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .get(`individual/bank-branches`, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};

export const getBanksAndBranchByCodeApi = async (code : any) => {
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .get(`individual/bank/branches/by/${code}`, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};


export const getIndividualApplicantsApi = async () => {
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .get(`individual/applications`, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};


export const calculateContributionCorporateApi = async (requestBody:any) => {
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .post(`/contribution/Corporate`, requestBody, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};

export const calculateContributionIndividualApi = async (requestBody:any) => {
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .post(`/contribution/Individual`, requestBody, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};


export const createUnderwritingCommentsApi = async (requestBody:any) => {
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .post(`/underwriting`, requestBody, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};

export const updateProofOfStudentApi = async (requestBody:any) => {
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .post(`/proof/of/student`, requestBody, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};

export const updateCorporatePayerDetails = async (requestBody:any) => {
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .post(`/corporate/payer/details`, requestBody, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};

export const updateCorporateWaiver = async (requestBody:any) => {
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .patch(`/corporate/waiver/update`, requestBody, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
};

export const getApplicationMemberFormIndividual=async(Id:any)=>{
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .get(`/Individual/membership/application/form/${Id}`, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
}

export const getApplicationMemberFormUnderwritingByCorporateId=async(Id:any)=>{
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .get(`/corporate/membership/application/form/underwriting/by/corporate/${Id}`, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
}

export const getApplicationMemberFormUnderwritingAll=async()=>{
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .get(`/corporate/membership/application/form/underwriting/all`, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
}

export const getApplicationMemberFormIndividualUnderwritingAllApi=async()=>{
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .get(`/individual/applications/underwriting/all`, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
}

export const getMembershipWithPOSPendingReviewApi=async()=>{
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .get(`/individual/applications/pos/review`, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
}

export const getUnderwritingMembershipPendingReviewApi=async()=>{
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .get(`/individual/applications/underwriting/review`, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
}

export const getApplicationMemberFormByCorporateIdApi=async(Id:any)=>{
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .get(`/corporate/membership/application/form/by/corporate/${Id}`, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
}

export const getDashboardStatisticsdApi=async()=>{
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .get(`/dashboard/statistics`, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
}

export const sendApplicationFormApi=async(Id:any)=>{
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .get(`/dashboard/send/application/form`, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
}



export const corporatePayerDetailsApi=async(Id:any)=>{
  const responseData = await coreApi
    .get(`/corporate/payer/by/${Id}`)
    .then((response) => {
      return response.data;
    });
  return responseData;
}


export const sendCorporateApplicationFormApi=async(requestBody:any)=>{
  const axiosConfig = getAxiosConfig();
  const responseData = await coreApi
    .post(`/corporate/send/application/form`,requestBody, axiosConfig)
    .then((response) => {
      return response.data;
    });
  return responseData;
}


const getAxiosConfig = () => {
 
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
      Authorization: null,
    },
  };

  const accessToken = JSON.parse(localStorage.getItem("userInfo"))?.token;

  if (accessToken) {
    axiosConfig.headers.Authorization = `Bearer ${accessToken}`;
  }
  return axiosConfig;
};

